/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M13.572 4.724a4.662 4.662 0 0 0 5.21 6.529v7.281c0 1.09-.883 1.973-1.973 1.973H4.973A1.973 1.973 0 0 1 3 18.534V6.697c0-1.09.883-1.973 1.973-1.973h8.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.796 3.493a3.205 3.205 0 0 0 0 6.408 3.205 3.205 0 0 0 0-6.408Z"
})), "0 0 24 24", "Inbox");